import firebase from '../firebase'

const ENDPOINT = 'https://us-central1-sisredvolucion2020.cloudfunctions.net'
const URL_ELIMINAR = `${ENDPOINT}/deleteInspirador`

const db = firebase.firestore()
const collectionInspiradores = db.collection('inspiradores')

export const guardarNuevoInspirador = async (inspirador, idMerani, login) => {
  // Validación si un inspirador ya existe por documento de identidad
  const exists = await db.collection('inspiradores').where('numeroIdentificacion', '==', inspirador.numeroIdentificacion).get()
  if (exists && exists.docs[0]) {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line prefer-promise-reject-errors
      return reject('El inspirador ya está registrado')
    })
  }

  inspirador.correo = inspirador.correo.toLowerCase()
  const promises = []
  inspirador.createdAt = Date.now()
  const authUser = await firebase.auth().createUserWithEmailAndPassword(inspirador.correo, inspirador.password ? inspirador.password : `CC${String(inspirador.numeroIdentificacion)}`)
  const { nombres, apellidos, departamento, municipio, numeroIdentificacion, createdAt, correo } = inspirador

  promises.push(authUser.user.uid)
  delete inspirador.passwordConf

  promises.push(db.collection('usuarios').doc(authUser.user.uid).set({
    nombres,
    apellidos,
    departamento,
    municipio,
    numeroIdentificacion,
    rol: 'inspirador',
    createdAt,
    correo
  }))

  inspirador.idMerani = db.doc(`usuarios/${idMerani}`)
  promises.push(collectionInspiradores.doc(authUser.user.uid).set(inspirador))

  return Promise.all(promises)
}

export const actualizarInspirador = (inspirador, idInspirador) => {
  inspirador.idMerani = db.doc(`usuarios/${inspirador.facilitador}`)
  return collectionInspiradores.doc(idInspirador).set(inspirador)
}

export const obtenerInspiradoresPorId = (refMerani) => {
  return collectionInspiradores.where('idMerani', '==', refMerani).get()
}

export const obtenerInspiradorPorId = (inspiradorId) => {
  return collectionInspiradores
    .doc(inspiradorId)
    .get()
}

export const guardarDocumento = (documento) => {
  return db.collection('documentos')
    .add(documento)
}

export const obtenerDocumentosPorDni = (dni) => {
  return db.collection('documentos')
    .where('dniUsuario', '==', dni)
    .get()
}

export const eliminarInspirador = async (params = null) => {
  let url = `${URL_ELIMINAR}?`

  if (params) {
    url += 'id=' + params
  }

  const response = await fetch(url)

  return response.json()
}
